import {Routes} from '@angular/router';

import {FilesComponent} from './components/files/files.component';
import {FilesDownloadComponent} from './components/files-download/files-download.component';
import {FilesCountDownloadComponent} from './components/files-count-download/files-count-download.component';


export const FILE_ROUTES: Routes = [
    {path: 'files/:gtype', component: FilesComponent},
    {path: 'files/:id/download', component: FilesDownloadComponent},
    {path: 'files-count/:id/download', component: FilesCountDownloadComponent}
];



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/files/file.routes.ts